import { render, staticRenderFns } from "./BarcodeConfiguration.vue?vue&type=template&id=4b857784&scoped=true&"
import script from "./BarcodeConfiguration.vue?vue&type=script&lang=js&"
export * from "./BarcodeConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeConfiguration.vue?vue&type=style&index=0&id=4b857784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b857784",
  null
  
)

export default component.exports